import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";

import addbutton from "../static/images/add-button.png";
//import o from "../static/images/0.png";
import o from "../static/images/logros_certificaciones_default.png";
import $ from "jquery";
import { Modal } from "react-bootstrap";
import { createEmitAndSemanticDiagnosticsBuilderProgram } from "typescript";
import useToggle from "../Hooks/useToggle";
import moment from "moment";

const LogrosCert = ({ data, edit }) => {
  const [mesArr] = useState([]);
  const [yearArr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userLogCert, setuserLogCert] = useState([]);
  const [selectLogCert, setselectLogCert] = useState("");
  const [actualCert, setactualCert] = useState(false);
  const [viewCredencial, setViewCredencial] = useToggle(false)
  const [credencial, setCredencial] = useState(null)

  const url = "#company__wrapper";


  useEffect(() => {
    let rol = localStorage.getItem("rol");
    if (data === undefined) {
      setLoading(true);
    } else {
      fillDate();
      GetLogCert();
    }
  }, [data]);

  function fillDate() {
    for (var i = 1; i <= 12; i++) {
      let mes = { value: "", desc: "" };

      mes.value = i;
      mes.desc = i;
      mesArr.push(mes);
    }

    let currentYear = new Date().getFullYear();
    let earliestYear = 1970;

    while (currentYear >= earliestYear) {
      let year = { value: "", desc: "" };

      year.value = currentYear.toString();
      year.desc = currentYear.toString();
      yearArr.push(year);
      currentYear -= 1;
    }
  }

  function GetLogCert() {
    axios
      .get("certification/list-certification-applicant/" + data)
      .then((result) => {
        setuserLogCert(result.data);
        setLoading(false);
      });
  }

  function GuardarLogCert(
    values,
    resetForm = () => {}
  ) {
    const startDate = new Date(values.anoInicio, values.mesInicio - 1);
    const endDate = new Date(values.anoFin, values.mesFin - 1);

    if (!actualCert) {
      if (endDate < startDate) {
        toast.error("Las fechas son inválidas, favor verifique!", {
          duration: 5000,
        });
        return;
      }
    }

    let logCert = {
      applicantId: data,
      certificationId: 0,
      certificationName: values.certificationName,
      courseName: values.courseName,
      credentialName: values.credentialName,
      instituteName: values.instituteName,
      certificationTypeId: 1,
      dateEnd: endDate,
      dateInit: startDate,
      enCurso: values.currentCert,
      description: values.description,
    };

    axios
      .post(
        "certification/create-applicantcertification",
        logCert
      )
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetLogCert();
          $("#agregar-log-modal").modal("hide");
          resetForm(true)
        }
      })
      .catch(function (error) {
        $("#agregar-log-modal").modal("hide");
      });
  }

  function ActualizarLogCert(values) {

    const startDate = new Date(values.anoInicio, parseInt(values.mesInicio) - 1);
    const endDate = new Date(values.anoFin, values.mesFin - 1);

    //validar que la fecha de inicio sea mayor que la fecha de fin
    
    if (!actualCert) {
      if (endDate < startDate) {
        toast.error("Las fechas son inválidas, favor verifique!", {
          duration: 5000,
        });
        return;
      }
    }

    let logCert = {
      applicantId: data,
      certificationId: selectLogCert.certificationId,
      certificationName: values.certificationName,
      courseName: values.courseName,
      credentialName: values.credentialName,
      instituteName: values.instituteName,
      certificationTypeId: 1,
      dateEnd: endDate,
      dateInit: startDate,
      enCurso: values.currentCert,
      description: values.description,
    };


    axios
      .post(
        "certification/update-applicantcertification",
        logCert
      )
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetLogCert();
          $("#actualizar-log-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#actualizar-log-modal").modal("hide");
      });
  }

  function FindLogCert(id) {
    setselectLogCert(userLogCert.find((i) => i.certificationId === id));
    setactualCert(userLogCert.find((i) => i.certificationId === id).enCurso);
  }

  function DeleteLogCert() {
    let logCert = {
      applicantId: data,
      certificationId: selectLogCert.certificationId,
      certificationName: "string",
      certificationTypeId: 0,
      courseName: "string",
      credentialName: "string",
      instituteName: "string",
    };

    axios
      .post("certification/delete-applicantcertification", logCert)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          GetLogCert();
          setactualCert(false);
          $("#eliminar-logCert-modal").modal("hide");
        }
      })
      .catch(function (error) {
        $("#eliminar-logCert-modal").modal("hide");
      });
  }

  const Validaciones = Yup.object().shape({
    courseName: Yup.string()
      .required("No puede estar vacio")
      .max(250, "No puede tener mas de 250 caracteres"),
    instituteName: Yup.string()
      .required("No puede estar vacio")
      .max(250, "No puede tener mas de 250 caracteres"),
  });

  function inHabilitarFechaFin() {
    setactualCert(!actualCert);
  }



  return (
    <Fragment>
      {loading ? (
        <label className="login-label">CARGANDO</label>
      ) : (
        <div className="box left-col">
          <div className="head">
            <div className="title">Cursos y Capacitaciones</div>
            {edit &&
              <button
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#agregar-log-modal"
                style={{border: "none"}}
              >
                <img src={addbutton} alt="Agregar Experiencia"></img>
              </button>
            }
          </div>
          {userLogCert.map((item, index) => {
            return (
              <div key={index} className="company">
                <div className="company__wrapper">
                  <div className="logo">
                    <img src={o} alt={"logocert" + index}></img>
                  </div>
                  <div className="content">
                    <div className="asistente">{item.courseName}</div>
                    <div className="name">{item.instituteName}</div>
                    <div>

                    <button style={{margin: "1rem 0", width: "4rem"}} className="btn-deg1" onClick={() => {
                      setCredencial(item)
                      setViewCredencial()
                    }}>
                      Ver 
                    </button>

                    </div>
                  </div>
                </div>
                <div id="job-description-1" className="collapse company__bio">
                  {item.description}
                </div>
                <div className="toolset">
                  {edit &&
                    <div>
                      <button
                        className="edit-button"
                        data-bs-toggle="modal"
                        data-bs-target="#actualizar-log-modal"
                        onClick={() => FindLogCert(item.certificationId)}
                      />
                      <button
                        className="delete-button"
                        data-bs-toggle="modal"
                        data-bs-target="#eliminar-logCert-modal"
                        onClick={() => FindLogCert(item.certificationId)}
                      />
                    </div>
                  }
                  <button
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#job-description-1"
                    aria-expanded="false"
                    aria-controls="job-description-1"
                    className="view-more"
                  >
                    Ver Más <i className="fas fa-chevron-down"></i>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Agregar Credencial */}
      <div
        id="agregar-log-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
                onClick={() => setactualCert(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <Formik
                initialValues={{
                  applicantId: data,
                  certificationId: 0,
                  certificationName: "",
                  courseName: "",
                  credentialName: "",
                  instituteName: "",
                  mesInicio: 1,
                  anoInicio: 2021,
                  mesFin: 1,
                  anoFin: 2021,
                  currentCert: false,
                  description: "",
                  actualCert: false,
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  GuardarLogCert(values, resetForm);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="form__title text-center">
                      Formulario para Agregar Cursos/Capacitaciones
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="instituteName" className="col-sm-2 pe-0">
                        Centro de Educación
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="instituteName"
                          name="instituteName"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.instituteName && touched.instituteName && (
                          <span className="form__validation form__validation--error">
                            {errors.instituteName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="courseName" className="col-sm-2 pe-0">
                        Nombre del Curso
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="courseName"
                          name="courseName"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.courseName && touched.courseName && (
                          <span className="form__validation form__validation--error">
                            {errors.courseName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label
                        htmlFor="certificationName"
                        className="col-sm-2 pe-0"
                      >
                        ID Credencial
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="certificationName"
                          name="certificationName"
                          type="text"
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.certificationName &&
                          touched.certificationName && (
                            <span className="form__validation form__validation--error">
                              {errors.certificationName}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="FechaInicio" className="col-sm-2 pe-0">
                        Fecha Inicio
                      </label>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="mesInicio"
                          id="mesInicio"
                          required
                          placeholder="Mes"
                          className="form-control form-control-sm"
                        >
                          {mesArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {months[item.desc]}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.mesInicio && touched.mesInicio && (
                          <span className="form__validation form__validation--error">
                            {errors.mesInicio}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="anoInicio"
                          id="anoInicio"
                          required
                          placeholder="Año"
                          className="form-control form-control-sm"
                        >
                          {yearArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.desc}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.anoInicio && touched.anoInicio && (
                          <span className="form__validation form__validation--error">
                            {errors.anoInicio}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <div className="col-sm-1">
                        <Field
                          type="checkbox"
                          name="currentCert"
                          id="currentCert"
                          checked={actualCert}
                          onClick={inHabilitarFechaFin}
                        ></Field>
                      </div>
                      <div className="col-sm-11">
                        <label
                          className="form-check-label"
                          htmlFor="cert-status"
                        >
                          Actualmente en preparación
                        </label>
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="FechaInicio" className="col-sm-2 pe-0">
                        Fecha Fin
                      </label>
                      <div className="col-sm-5">
                        <Field
                          disabled={actualCert}
                          as="select"
                          name="mesFin"
                          id="mesFin"
                          placeholder="Mes"
                          className="form-control form-control-sm"
                          required
                        >
                          {" "}
                          {mesArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {months[item.desc]}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.mesFin && touched.mesFin && (
                          <span className="form__validation form__validation--error">
                            {errors.mesFin}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-5">
                        <Field
                          disabled={actualCert}
                          as="select"
                          name="anoFin"
                          id="anoFin"
                          placeholder="Año"
                          className="form-control form-control-sm"
                          required
                        >
                          {yearArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.desc}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.anoFin && touched.anoFin && (
                          <span className="form__validation form__validation--error">
                            {errors.anoFin}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="description" className="col-sm-2 pe-0">
                        Comentarios adicionales
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="description"
                          name="description"
                          as="textarea"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.description && touched.description && (
                          <span className="form__validation form__validation--error">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                        onClick={() => setactualCert(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--small btn--purple"
                      >
                        <i className="fas fa-paper-plane"></i>Aceptar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Editar Credencial */}
      <div
        id="actualizar-log-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
                onClick={() => setactualCert(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  applicantId: data,
                  certificationId: selectLogCert.certificationId,
                  certificationName: selectLogCert?.certificationName ?? "",
                  courseName: selectLogCert?.courseName ?? "",
                  instituteName: selectLogCert?.instituteName ?? "",
                  actualCert: selectLogCert?.enCurso ?? false,
                  description: selectLogCert?.description ?? "",
                  mesInicio:  getDate(selectLogCert?.dateInit).getMonth() + 1,
                  anoInicio: getDate(selectLogCert?.dateInit).getFullYear(),
                  mesFin: getDate(selectLogCert?.dateEnd).getMonth() + 1,
                  anoFin: getDate(selectLogCert?.dateEnd).getFullYear()
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  ActualizarLogCert(values);
                  //resetForm(true);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="form__title text-center">
                      Formulario para Actualizar Logro/Certificación
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="instituteName" className="col-sm-2 pe-0">
                        Centro de Educación
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="instituteName"
                          name="instituteName"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.instituteName && touched.instituteName && (
                          <span className="form__validation form__validation--error">
                            {errors.instituteName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="courseName" className="col-sm-2 pe-0">
                        Nombre del Curso
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="courseName"
                          name="courseName"
                          type="text"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.courseName && touched.courseName && (
                          <span className="form__validation form__validation--error">
                            {errors.courseName}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label
                        htmlFor="certificationName"
                        className="col-sm-2 pe-0"
                      >
                        ID Credencial
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="certificationName"
                          name="certificationName"
                          type="text"
                          
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.certificationName &&
                          touched.certificationName && (
                            <span className="form__validation form__validation--error">
                              {errors.certificationName}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="FechaInicio" className="col-sm-2 pe-0">
                        Fecha Inicio
                      </label>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="mesInicio"
                          id="mesInicio"
                          required
                          placeholder="Mes"
                        >
                          {mesArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {months[item.desc]}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.mesInicio && touched.mesInicio && (
                          <span className="form__validation form__validation--error">
                            {errors.mesInicio}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-5">
                        <Field
                          as="select"
                          name="anoInicio"
                          id="anoInicio"
                          required
                          placeholder="Año"
                        >
                          {yearArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.desc}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.anoInicio && touched.anoInicio && (
                          <span className="form__validation form__validation--error">
                            {errors.anoInicio}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <div className="col-sm-1">
                        <Field
                          type="checkbox"
                          name="currentCert"
                          id="currentCert"
                          checked={actualCert}
                          onClick={inHabilitarFechaFin}
                        ></Field>
                      </div>
                      <div className="col-sm-11">
                        <label
                          className="form-check-label"
                          htmlFor="cert-status"
                        >
                          Actualmente en preparación
                        </label>
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="FechaFin" className="col-sm-2 pe-0">
                        Fecha Fin
                      </label>
                      <div className="col-sm-5">
                        <Field
                          disabled={actualCert}
                          as="select"
                          name="mesFin"
                          id="mesFin"
                          placeholder="Mes"
                          className="form-select form-select-sm"
                          required
                        >
                          {" "}
                          {mesArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {months[item.desc]}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.mesFin && touched.mesFin && (
                          <span className="form__validation form__validation--error">
                            {errors.mesFin}
                          </span>
                        )}
                      </div>
                      <div className="col-sm-5">
                        <Field
                          disabled={actualCert}
                          as="select"
                          name="anoFin"
                          id="anoFin"
                          placeholder="Año"
                          className="form-select form-select-sm"
                          required
                        >
                          {yearArr.map((item, index) => {
                            return (
                              <option key={index} value={item.value}>
                                {item.desc}
                              </option>
                            );
                          })}
                        </Field>
                        {errors.anoFin && touched.anoFin && (
                          <span className="form__validation form__validation--error">
                            {errors.anoFin}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="description" className="col-sm-2 pe-0">
                        Comentarios adicionales
                      </label>
                      <div className="col-sm-10">
                        <Field
                          id="description"
                          name="description"
                          as="textarea"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.description && touched.description && (
                          <span className="form__validation form__validation--error">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                        onClick={() => setactualCert(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--small btn--purple"
                      >
                        <i className="fas fa-paper-plane"></i>Aceptar
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {/* Eliminar Credencial */}
      <div
        id="eliminar-logCert-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
                onClick={() => setactualCert(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">
                    Eliminar Logro/Certificacion
                  </div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeleteLogCert()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <ModalShowCredencial show={viewCredencial} toggle={setViewCredencial} credencial={credencial} />
    </Fragment>
  );
};

var months = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre",
};


function ModalShowCredencial({show, toggle, credencial}) {


  if(!credencial) {
    return <></>
  }

  function isValidDate(date) {
    return isNaN((new Date(date)).valueOf())
  }
  
  return (
    <>
      <Modal show={show} onHide={toggle} className="kr-modal" size="lg">

        <Modal.Body>
          <h2 className="text-center">{credencial?.courseName}</h2>

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                </tr>
              </thead>

              <tbody style={{fontSize: "1.25rem"}}>

                <tr>
                  <td>Centro de educación</td>
                  <td>{credencial?.instituteName}</td>
                </tr>

                <tr>
                  <td>Fecha Inicio</td>
                  <td>
                    {!isValidDate(credencial?.dateInit) 
                      ? moment(credencial?.dateInit ,"YYYY-MM-DD").format("MMMM-YYYY") 
                      : credencial?.dateInit
                    }
                  </td>
                </tr>

                <tr>
                  <td>Fecha Fin</td>
                  <td>
                    { credencial?.enCurso
                        ?  "Actualmente en curso"
                        :  (!isValidDate(credencial?.dateEnd) 
                            ? moment(credencial?.dateEnd ,"YYYY-MM-DD").format("MMMM-YYYY") 
                            : credencial?.dateEnd)
                    }
                  </td>
                </tr>

                <tr>
                  <td>Comentarios</td>
                  <td>{credencial?.description}</td>
                </tr>
                <tr>
                  <td>ID credencial</td>
                  <td>{credencial?.certificationName}</td>
                </tr>
              </tbody>
            </table>

            { (credencial?.certificationName && isValidHttpUrl(credencial?.certificationName)) ?
              <div className="d-flex justify-content-center my-3">

                <button onClick={() => toggle()} className="btn-deg1 mr-3" style={{backgroundColor: "grey", color: "#000000", minWidth: "150px", width: "auto"}}>
                  Cerrar
                </button>

                {/* <a href={credencial.certificationName} rel="noreferrer" className="btn-deg1" style={{width: "auto"}}>
                  Ver sitio de certificación
                </a> */}

              </div>


              : (
                <div className="d-flex justify-content-center my-3">

                  <button onClick={() => toggle()} className="btn-deg1 mr-3" style={{backgroundColor: "grey", color: "#000000", minWidth: "150px", width: "auto"}}>
                    Cerrar
                  </button>

                </div>
              )
            }

            
            
          </div>
        </Modal.Body>

      </Modal>
    </>
  )
}


function isValidHttpUrl(string) {
  let url;
  
  try {
    url = new URL(string);
  } catch (_) {
    return false;  
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

function getDate(date) {

  if(date === null)
    return new Date()


  if(isNaN(new Date(date)).valueOf())
    return new Date()


  return moment(date, "YYYY-MM-DD").add(1, "day").toDate()
}

export default LogrosCert;
